import api from 'api'

/** Mirrors crm-core controller/v1/core/intercom/CreateIntercomTokenResponse.java */
interface GenerateIntercomTokenResponse {
  token: string
  userId: string
}

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    generateIntercomToken: build.query<GenerateIntercomTokenResponse, void>({
      query: () => ({
        url: '/api/v1/intercom/generate-token',
        method: 'POST',
      }),
    }),
  }),
})

export const { useLazyGenerateIntercomTokenQuery } = extendedApi
